import React from 'react';
import { Power, Loader2 } from 'lucide-react';

export const EntityStatusToggle = ({ entity, onToggle, loading }) => {
  const isActive = entity.isActive;
  return (
    <button
      onClick={() => onToggle(entity)}
      disabled={loading}
      className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
        isActive
          ? 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
          : 'bg-green-100 text-green-700 hover:bg-green-200'
      }`}
      title={isActive ? 'Passiv et' : 'Aktiv et'}
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        <Power className="w-4 h-4" />
      )}
    </button>
  );
};
